import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import FooterSection from './FooterSection';
import './StudentLogin.css';

export default function StudentLogin() {
  const [admNumber, setAdmNumber] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setMessage({ type: '', text: '' });

//     if (!admNumber || !password) {
//       setMessage({ type: 'error', text: 'Please fill in both fields.' });
//       return;
//     }

//     setLoading(true);

//     try {
//       const response = await fetch('https://metapi.emedhatechnologies.com/api/students/student/login', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ admNumber, password })
//       });

//       const data = await response.json();

//       if (data.success) {
//         setMessage({ type: 'success', text: 'Login successful! Redirecting...' });
        
//         // Save session data if needed
//         sessionStorage.setItem('studentSession', JSON.stringify(data.student));

//         // setTimeout(() => {
//         //   navigate('/dashboard'); // Redirect target
//         // }, 1200);
//       } else {
//         setMessage({ type: 'error', text: data.message || 'Invalid credentials' });
//       }
//     } catch (error) {
//       console.error('Login Error:', error);
//       setMessage({ type: 'error', text: 'Server error. Please try again later.' });
//     } finally {
//       setLoading(false);
//     }
//   };



const handleLogin = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });

    if (!admNumber || !password) {
      setMessage({ type: 'error', text: 'Please fill in both fields.' });
      return;
    }

    setLoading(true);

    try {
      const response = await fetch('https://metapi.emedhatechnologies.com/api/students/student/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ admNumber, password })
      });

      const data = await response.json();

      if (data.success) {
        // Save student info to local/session storage for future dashboard state
        sessionStorage.setItem('studentSession', JSON.stringify(data.student));

        // Updated Alert Message for Future Dashboard Launch
        setMessage({ 
          type: 'success', 
          text: `Welcome, ${data.student.name || 'Student'}! Login successful. (Student Dashboard Coming Soon)` 
        });
      } else {
        setMessage({ type: 'error', text: data.message || 'Invalid credentials' });
      }
    } catch (error) {
      console.error('Login Error:', error);
      setMessage({ type: 'error', text: 'Server error. Please try again later.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="student-login-page-wrapper">
        <div className="login-card-container">
          
          {/* Top Brand Logo Circle */}
          <div className="brand-logo-badge">
            <span className="grad-cap-icon">🎓</span>
          </div>

          {/* Title Header */}
          <div className="portal-header-text">
            <h2>Student Portal</h2>
            <p>CDOE, EDULEARNER</p>
          </div>

          {/* Form Card Shell */}
          <div className="login-form-card">
            
            {/* Dark Blue Header Banner inside Card */}
            <div className="card-top-banner">
              <h3>Student Login</h3>
              <p>Enter your registration number and password</p>
            </div>

            {/* Login Inputs Form */}
            <form onSubmit={handleLogin} className="login-form-body">
              
              {/* Feedback Alert */}
              {message.text && (
                <div className={`alert-message-box ${message.type}`}>
                  {message.text}
                </div>
              )}

              {/* Admission Number Field */}
              <div className="input-group-field">
                <label>Admission Number *</label>
                <div className="input-with-icon">
                  <span className="input-icon">👤</span>
                  <input
                    type="text"
                    placeholder="e.g. MET-ADM-5"
                    value={admNumber}
                    onChange={(e) => setAdmNumber(e.target.value)}
                    required
                  />
                </div>
              </div>

              {/* Password Field */}
              <div className="input-group-field">
                <label>Password *</label>
                <div className="input-with-icon">
                  <span className="input-icon">📅</span>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    className="toggle-visibility-btn"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? '👁️' : '👁️‍🗨️'}
                  </button>
                </div>
              </div>

              {/* Demo Hint Banner */}
              <div className="demo-hint-box">
                <strong>Demo:</strong> Reg No: <span>MET-ADM-5</span> | Pass: <span>MET@3077</span>
              </div>

              {/* Submit Button */}
              <button type="submit" className="btn-portal-login" disabled={loading}>
                {loading ? 'Logging in...' : 'Login to Portal'}
              </button>

              {/* Forgot Link */}
              <div className="forgot-link-wrapper">
                <a href="#forgot" className="forgot-link">Forgot Password?</a>
              </div>

            </form>

          </div>

          {/* Bottom Footer Callout */}
          <div className="not-student-footer">
            Not a student yet? <Link to="/admissions" className="apply-link">Apply Now →</Link>
          </div>

        </div>
      </div>
      <FooterSection />
    </>
  );
}